module.exports = __webpack_public_path__ + "img/auth_fail.063022fd.png";